import contract from '@mailobj-browser/front/js/contracts/contract.js'
import domain_migration from './domain_migration/domain_migration.js'
import migrationU_openauth from './migrationU_openauth/migrationU_openauth.js'
import registrar_add from './registrar_add/registrar_add.js'
import registrarInfos from './registrarInfos/registrarInfos.js'
import registrarSearch from './registrarSearch/registrarSearch.js'
import fridge from './fridge/fridge.js'

export default contract({
  domain_migration,
  fridge,
  migrationU_openauth,
  registrar_add,
  registrarInfos,
  registrarSearch
})
